<div class="page-wrap">
    <div class="replace-matcard">
        <mat-card-header *ngIf="regionData != null">
            <h1>{{datamanagement?.titelEdit}}: {{regionData.name}}</h1>
        </mat-card-header>
        <mat-card-content class="card-content">
            <mat-tab-group
                *ngIf="regionData != null && valueFormats != null && ageGender != null && luggageTypes != null && seasons != null && transportModes != null && serviceClasses != null && comfortTypes != null && storageSpaces != null">
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab1Titel}}</ng-template>
                    <app-transport-defaults class="component-style" [data]="regionData" [form]="regionForm"
                        [valueFormats]="valueFormats" [isEditable]="isEditable"></app-transport-defaults>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab30Titel}}</ng-template>
                    <app-special-factors class="component-style" #specialFactorsChild
                        [luggagePerFoldingSeat]="regionData.luggagePerFoldingSeat"
                        [rackCapacityRoundingThreshold]="regionData.rackCapacityRoundingThreshold"
                        [minimumUnderSeatHeight]="regionData.minimumUnderSeatHeight"
                        [overheadHeightReductionFactor]="regionData.overheadHeightReductionFactor"
                        [overheadLengthReductionFactor]="regionData.overheadLengthReductionFactor"
                        [overheadLengthReductionThreshold]="regionData.overheadLengthReductionThreshold"
                        [handleReductionFactor]="regionData.handleReductionFactor"
                        [distanceBetweenPeople]="regionData.distanceBetweenPeople"
                        [distanceBetweenPeopleAisle]="regionData.distanceBetweenPeopleAisle"
                        [distanceBetweenPeopleStairs]="regionData.distanceBetweenPeopleStairs"
                        [securityAdjustmentFactors]="regionData.securityAdjustmentFactor"
                        [transportModes]="transportModes" [rackSecurities]="rackSecurities" [form]="regionForm"
                        [oppositeDoorReductionFactorValue]="regionData.oppositeDoorReductionFactorValue"
                        [beforeSeatReductionFactorValue]="regionData.beforeSeatReductionFactorValue"
                        [notUsableSeatFactorValue]="regionData.notUsableSeatFactorValue" [isEditable]="isEditable"
                        [overencumberFactor]="regionData.overencumberFactor">
                    </app-special-factors>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab2Titel}}</ng-template>
                    <app-age-gender-distribution class="component-style" #ageGenderDistributionChild
                        [data]="regionData.ageGenderDistribution" [form]="regionForm" [isEditable]="isEditable"
                        [isSumDisplayed]="true" [isImported]="isImported"
                        (validationCheckOutput)="updateValiadationAgeGenderDistribution($event)">
                    </app-age-gender-distribution>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab3Titel}}</ng-template>
                    <app-age-gender-luggage-factor class="component-style" #ageGenderLuggageFactorChild
                        [data]="regionData.ageGenderLuggageFaktor" [form]="regionForm" [colHeaders]="ageGender"
                        [rowHeaders]="luggageTypes" [isEditable]="isEditable"></app-age-gender-luggage-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab4Titel}}</ng-template>
                    <app-luggage-size class="component-style" #luggageSizeChild [data]="regionData.luggageSize"
                        [form]="regionForm" [colHeaders]="luggageTypes" [isEditable]="isEditable"></app-luggage-size>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab5Titel}}</ng-template>
                    <app-travelmix [data]="regionData.travelMixes" class="component-style" [form]="regionForm"
                        [seasons]="seasons" [transportModes]="transportModes" [serviceClasses]="serviceClasses"
                        [luggageTypes]="luggageTypes" [isEditable]="isEditable"
                        (validationCheckOutput)="updateValidationTravelMix($event)"></app-travelmix>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab6Titel}}</ng-template>
                    <app-storage-acceptance #storageAcceptanceChild class="component-style"
                        [data]="regionData.storageAcceptance" [form]="regionForm" [comfortTypes]="comfortTypes"
                        [colHeaders]="luggageTypes" [rowHeaders]="storageSpaces"
                        [isEditable]="isEditable"></app-storage-acceptance>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab7Titel}}</ng-template>
                    <app-age-gender-storage-factor #ageGenderStorageFactorChild class="component-style"
                        [data]="regionData.ageGenderStorageFactor" [form]="regionForm" [colHeaders]="ageGender"
                        [rowHeaders]="storageSpaces" [isEditable]="isEditable"></app-age-gender-storage-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab8Titel}}</ng-template>
                    <app-age-gender-adaptation #ageGenderAdaptation class="component-style"
                        [data]="regionData.ageGenderAdaptation" [form]="regionForm" [colHeaders]="luggeCategory"
                        [rowHeaders]="ageGender" [isEditable]="isEditable"
                        [timeType]="timeType"></app-age-gender-adaptation>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab9Titel}}</ng-template>
                    <app-passenger-change-time-vector #passengerChangeTimeVector class="component-style"
                        [data]="regionData.passengerChangeTimeVector" [form]="regionForm" [colHeaders]="stepsAmount"
                        [rowHeaders]="luggeCategory" [isEditable]="isEditable" [timeType]="timeType">
                    </app-passenger-change-time-vector>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab10Titel}}</ng-template>
                    <app-door-width-reduction #doorWidthReduction class="component-style"
                        [data]="regionData.doorWidthReduction" [form]="regionForm" [colHeaders]="standback"
                        [rowHeaders]="doorWidthReal" [isEditable]="isEditable"></app-door-width-reduction>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab10komma5Titel}}</ng-template>
                    <app-door-width-and-physical-separation-factor #doorWidthAndPhysicalSeparationFactor
                        class="component-style" [data]="regionData.doorWidthAndPhysicalSeparationFactor"
                        [form]="regionForm" [rowHeaders]="doorWidthCalculated" [isEditable]="isEditable">
                    </app-door-width-and-physical-separation-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab11Titel}}</ng-template>
                    <app-base-value-time #baseValueTime class="component-style" [data]="regionData.baseValueTime"
                        [form]="regionForm" [isEditable]="isEditable"></app-base-value-time>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab12Titel}}</ng-template>
                    <app-base-factor #baseFactor class="component-style" [data]="regionData.baseFactor"
                        [form]="regionForm" [isEditable]="isEditable"></app-base-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab13Titel}}</ng-template>
                    <app-polynomial-factor #polynomialFactor class="component-style"
                        [data]="regionData.polynomialFactor" [form]="regionForm"
                        [isEditable]="isEditable"></app-polynomial-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab14Titel}}</ng-template>
                    <app-aisle-width #aisleWidth class="component-style" [data]="regionData.aisleWidth"
                        [averageAisleWidth]="averageAisleWidth" [form]="regionForm"
                        [isEditable]="isEditable"></app-aisle-width>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab15Titel}}</ng-template>
                    <app-alternative-rooms #alternativeRooms class="component-style"
                        [data]="regionData.alternativeRooms"
                        [factorDistributionOfAlternativeRooms]="factorDistributionOfAlternativeRooms"
                        [form]="regionForm" [isEditable]="isEditable"></app-alternative-rooms>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab16Titel}}</ng-template>
                    <app-accessibility-of-the-seats-factor #accessibilityOfTheSeats class="component-style"
                        [data]="regionData.accessibilityOfTheSeats"
                        [accessibilityOfTheSeatsFactor]="accessibilityOfTheSeatsFactor" [form]="regionForm"
                        [isEditable]="isEditable"></app-accessibility-of-the-seats-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab17Titel}}</ng-template>
                    <app-amount-of-not-storable-baggage #amountOfNotStorableBaggage class="component-style"
                        [data]="regionData.amountOfNotStorableBaggage"
                        [notStorableBaggageFactor]="notStorableBaggageFactor" [form]="regionForm"
                        [isEditable]="isEditable"></app-amount-of-not-storable-baggage>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab18Titel}}</ng-template>
                    <app-simplicity-luggage-accommodation-factor #simplicityLuggageAccommodation class="component-style"
                        [data]="regionData.simplicityLuggageAccommodation"
                        [simplicityLuggageAccommodationFactor]="simplicityLuggageAccommodationFactor"
                        [form]="regionForm" [isEditable]="isEditable"></app-simplicity-luggage-accommodation-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab19Titel}}</ng-template>
                    <app-luggage-racks-when-boarding #luggageRacksWhenBoarding class="component-style"
                        [data]="regionData.luggageRacksWhenBoarding" [form]="regionForm" [isEditable]="isEditable">
                    </app-luggage-racks-when-boarding>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab20Titel}}</ng-template>
                    <app-baggage-accumulation #baggageAccumulation class="component-style"
                        [data]="regionData.baggageAccumulation" [baggageAccumulationFactor]="baggageAccumulationFactor"
                        [form]="regionForm" [isEditable]="isEditable"></app-baggage-accumulation>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab21Titel}}</ng-template>
                    <app-reservation-obligation #reservationObligation class="component-style"
                        [data]="regionData.reservationObligation" [form]="regionForm"
                        [isEditable]="isEditable"></app-reservation-obligation>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab22Titel}}</ng-template>
                    <app-compartments-available #compartmentsAvailable class="component-style"
                        [data]="regionData.compartmentsAvailable" [form]="regionForm"
                        [isEditable]="isEditable"></app-compartments-available>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab23Titel}}</ng-template>
                    <app-seats-per-running-meter-factor #seatsPerRunningMeter class="component-style"
                        [data]="regionData.seatsPerRunningMeter" [form]="regionForm"
                        [seatsPerRunningMeterFactor]="seatsPerRunningMeterFactor"
                        [isEditable]="isEditable"></app-seats-per-running-meter-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab24Titel}}</ng-template>
                    <app-age-distribution #ageDistribution class="component-style" [data]="regionData.ageDistribution"
                        [form]="regionForm" [ageGender]="ageGender" [isEditable]="isEditable"></app-age-distribution>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab25Titel}}</ng-template>
                    <app-age-gender-adaptation-steps #ageGenderAdaptationSteps class="component-style"
                        [data]="regionData.ageGenderAdaptationSteps" [form]="regionForm" [colHeaders]="luggeCategory"
                        [rowHeaders]="ageGender" [isEditable]="isEditable" [timeType]="timeType">
                    </app-age-gender-adaptation-steps>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab26Titel}}</ng-template>
                    <app-passenger-change-time-vector-steps #passengerChangeTimeVectorSteps class="component-style"
                        [data]="regionData.passengerChangeTimeVectorSteps" [form]="regionForm"
                        [rowHeaders]="luggeCategory" [isEditable]="isEditable" [timeType]="timeType">
                    </app-passenger-change-time-vector-steps>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab27Titel}}</ng-template>
                    <app-steps-width-factor #stepsWidthFactor class="component-style"
                        [data]="regionData.stepsWidthFactor" [form]="regionForm" [rowHeaders]="stepsWidth"
                        [isEditable]="isEditable" [timeType]="timeType">
                    </app-steps-width-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab28Titel}}</ng-template>
                    <app-boarding-place-density-of-people-factor #boardingPlaceDensityOfPeopleFactor
                        class="component-style" [data]="regionData.boardingPlaceDensityOfPeopleFactor"
                        [form]="regionForm" [isEditable]="isEditable" [transportModes]="transportModes">
                    </app-boarding-place-density-of-people-factor>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>{{datamanagement?.tab29Titel}}</ng-template>
                    <app-location-ways-factor #locationWaysFactor class="component-style"
                        [data]="regionData.locationWaysFactor" [form]="regionForm" [isEditable]="isEditable"
                        [places]="places"></app-location-ways-factor>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <div class="content-buttons margin-top-15">
            <button mat-raised-button class="color" (click)="navigateBack()">{{datamanagement?.buttonBack}}</button>
            <div class="spacer"></div>
            <button *ngIf="!isEditable" [disabled]="!validationCheck || !regionForm.valid" mat-raised-button class="color"
                (click)="onSubmit()">{{datamanagement?.buttonSave}}</button>
        </div>
    </div>
</div>
<hr class="line">